import { InternalServerError } from './errors';
import {
  HttpApiEndpoint,
  HttpApiGroup,
  HttpApiSchema,
  OpenApi,
} from 'effect/http-api';
import { Schema } from 'effect';

/**
 * POST /v2/email/mailgun-webhook
 * Handles Mailgun forwarded emails — HMAC-verified, no user auth.
 * Converts email attachments or body to audio via the conversion pipeline.
 */
const mailgunWebhookEndpoint = HttpApiEndpoint.post(
  'MailgunWebhook',
  '/mailgun-webhook',
  {
    success: Schema.Void.pipe(HttpApiSchema.status(204)),
    error: InternalServerError,
  },
)

  .annotate(OpenApi.Summary, 'Mailgun email webhook')
  .annotate(
    OpenApi.Description,
    'Receives forwarded emails from Mailgun. Verifies HMAC signature, extracts attachments or email body, and triggers audio conversion.',
  );

export const emailGroup = HttpApiGroup.make('Email')
  .add(mailgunWebhookEndpoint)
  .prefix('/v2/email');
